type NumberRange = {
  start: number;
  length: number;
  end: number;
};

type Point = {
  x: number;
  y: number;
  translate(dX: number, dY: number): Point;
};

// Source: https://stackoverflow.com/a/34003331/684353
// @ts-ignore
if (!Element.prototype.scrollIntoViewIfNeeded) {
  // @ts-ignore
  Element.prototype.scrollIntoViewIfNeeded = function (centerIfNeeded?: boolean) {
    function makeRange(start: number, length: number): NumberRange {
      return { start: start, length: length, end: start + length };
    }

    function coverRange(inner: NumberRange, outer: NumberRange) {
      if (false === centerIfNeeded || (outer.start < inner.end && inner.start < outer.end)) {
        return Math.min(inner.start, Math.max(outer.start, inner.end - outer.length));
      }
      return (inner.start + inner.end - outer.length) / 2;
    }

    function makePoint(x: number, y: number) {
      return {
        x: x,
        y: y,
        translate: function translate(dX: number, dY: number) {
          return makePoint(x + dX, y + dY);
        },
      };
    }

    function absolute(elem: Element, pt: Point) {
      let htmlElement: HTMLElement | null = elem as HTMLElement;
      while (htmlElement) {
        pt = pt.translate(htmlElement.offsetLeft, htmlElement.offsetTop);
        htmlElement = (htmlElement as HTMLElement).offsetParent as HTMLElement;
      }
      return pt;
    }

    let target = absolute(this, makePoint(0, 0));
    // @ts-ignore
    const extent = makePoint(this.offsetWidth, this.offsetHeight);
    let elem = this.parentNode;
    let origin;

    while (elem instanceof HTMLElement) {
      // Apply desired scroll amount.
      origin = absolute(elem, makePoint(elem.clientLeft, elem.clientTop));
      elem.scrollLeft = coverRange(
        makeRange(target.x - origin.x, extent.x),
        makeRange(elem.scrollLeft, elem.clientWidth)
      );
      elem.scrollTop = coverRange(
        makeRange(target.y - origin.y, extent.y),
        makeRange(elem.scrollTop, elem.clientHeight)
      );

      // Determine actual scroll amount by reading back scroll properties.
      target = target.translate(-elem.scrollLeft, -elem.scrollTop);
      elem = elem.parentNode;
    }
  };
}
